module.exports = __webpack_public_path__ + "static/scale-model-of-louisville-kentucky-b3f76e4b0fb09847b01ed4d9109f7976.png";